import React, { ReactNode } from 'react'
import classNames from 'classnames'
import { NormalizedMedia } from '@evertel/media'
import { Icon } from './Icon'
import { Button } from './Button'

export interface HoverMediaProps {
    children: ReactNode
    className?: string
    onDownload: () => void
}

const HoverMedia: React.FC<HoverMediaProps> = ({
    children,
    className,
    onDownload
}) => {
    const handleDownload = (e: React.MouseEvent | React.KeyboardEvent) => {
        e.preventDefault()
        e.stopPropagation()

        onDownload()
    }

    const containerClasses = classNames(
        'hover-media-container',
        className
    )

    return (
        <div className={containerClasses}>
            {children}

            <div className="hover-media-overlay">
                <div
                    role="button"
                    tabIndex={0}
                    className="btn btn-secondary btn-sm"
                    onClick={handleDownload}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            handleDownload(e)
                        }
                    }}
                >
                    <Icon
                        name="cloud-arrow-down"
                        faProps={{title: 'Download'}}
                    />
                </div>
            </div>
        </div>
    )
}

export { HoverMedia }
